module.exports = __webpack_public_path__ + "static/assinatura-digital-receitas-tooltip-01a5706bbc2cd7b62333ac44eee8b2a3.svg";